export enum PageType {
  Results = 'results',
  Itinerary = 'itinerary',
  GetMeThere = 'gmt'
}
